var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: "请选择流程分类",
        "close-on-click-modal": false,
        visible: _vm.visible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm._v(" " + _vm._s(_vm.selectCategoryName) + " "),
      _c("el-tree", {
        ref: "categoryTree",
        staticClass: "filter-tree",
        attrs: {
          data: _vm.categoryTreeData,
          props: {
            value: "id", // ID字段名
            label: "name", // 显示名称
            children: "children", // 子级字段名
          },
          "default-expand-all": "",
          "expand-on-click-node": false,
        },
        on: { "node-click": _vm.handleNodeClick },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.inputForm.category },
              on: {
                click: function ($event) {
                  return _vm.inputFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }